import { OrganizationType } from '@upright/common/iam/organizations/organization-types';
// Type-only, so the unit-test runner never loads the hook module behind it.
import type { FrontPage } from '@upright/ui/views/home-views/front-page-config';

/**
 * Which unified shell a user belongs in, before the opt-in is asked: the investor one, the company
 * one (PLT-6943), or none.
 *
 * The front page alone is not enough for the company branch. It is read off user groups ("in a
 * company group and in no investor group"), and a few DMA Consultant, DMA Freemium and Other
 * organisations have users in a company group too. Those are out of the company shell's scope, and
 * a DMA consultant in it would meet a chat launcher under a rail that hides chat off-company
 * (`useAskAiEntryPoint`). So the company branch also needs an organisation of type Company and a
 * user who is not a DMA user. The investor branch is the front page alone, as it always was.
 *
 * Pure so the decision is unit-tested; `useUnifiedShellAudience` feeds it.
 */
export type UnifiedShellAudience = 'investor' | 'company' | null;

export function unifiedShellAudience(args: {
  frontPage: FrontPage;
  organizationType: OrganizationType | undefined;
  isDmaUser: boolean;
}): UnifiedShellAudience {
  if (args.frontPage === 'investor') return 'investor';
  if (args.frontPage === 'company' && args.organizationType === OrganizationType.COMPANY && !args.isDmaUser) {
    return 'company';
  }
  return null;
}
